import { combineReducers } from "@reduxjs/toolkit";
import customerSlice from "../slice/customer-slice/customer-slice";

const customerReducer = combineReducers({
	customer: customerSlice,
});

export default customerReducer;